import { Button } from '@/components/ui/button';
import { useUIStore } from '@/stores/uiStore';

export function Header() {
  const theme = useUIStore((s) => s.theme);
  const toggleTheme = useUIStore((s) => s.toggleTheme);
  return (
    <header className="bg-card border-b border-border">
      <div className="container mx-auto container-max px-4 py-4 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="h-8 w-8 rounded-full bg-primary" />
          <span className="font-serif text-xl text-text-primary">LinkedIn Post Formatter</span>
        </div>
        <div className="flex items-center gap-3">
          <span className="text-sm text-text-secondary">
            {theme === 'dark' ? 'Dark' : 'Light'} mode
          </span>
          <Button variant="secondary" onClick={toggleTheme}>
            Toggle Theme
          </Button>
        </div>
      </div>
    </header>
  );
}
